import React from 'react';
import { useTranslationText } from 'locale';
import { Div, HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { IUser, IReview, ISearchReviewsInput } from 'types/types';
import { AppColors } from 'helpers';
import { TextDisplay } from 'vendor-deprecated/Text';
import { RateView } from './RateView';
import { Image } from 'components/common/vendors/Image';
import { dateUtil } from 'helpers/dateUtils';
import { useGetReviewList } from 'api/review/useGetReviewList';
import { useAppSetting } from 'helpers/useAppSetting';
import { Hr } from 'vendor-deprecated/CommonParts';
import { AnimationView } from 'vendor-deprecated/Animation';
import { PaginationBar } from 'components/common/components/Pagination/PaginationBar';
import { Button } from 'vendor-deprecated/Button';
import { WriteReviewBar } from 'components/common/components/Review/WriteReviewBar';
import { SVGIcon } from 'vendor-deprecated/Icon';
import { useSearchReviews } from 'hooks/api/review/useSearchReviews';

type ReviewListProps = {
  auth?: IUser;
  isValidReview: boolean;
  createdBy?: string;
  courseId: string;
  onEditReview: (id: string, rate: number, content: string) => void;
  onCreateReview: (rate: number, content: string) => void;
};

export const ReviewCard = (props: {
  auth?: IUser;
  review: IReview;
  onEditReview: (id: string, rate: number, content: string) => void;
}) => {
  const { appSize } = useAppSetting();
  const { translation } = useTranslationText();
  const { review } = props;

  const [isEdit, setIsEdit] = React.useState(false);

  return (
    <HorizontalView
      fullWidth
      alignContent={'topLeft'}
      //   border={props.auth?.id === review.userId ? `1px solid ${AppColors.BORDER}` : undefined}
      paddingBottom={'20px'}
      //   background={props.auth?.id === review.userId ? `white` : undefined}
      //   padding={props.auth?.id === review.userId ? `20px` : undefined}
      borderRadius={'4px'}
    >
      {/* FBFBF8 */}
      <HorizontalView width={'40px'} height={'40px'} borderRadius={'20px'} overflow={'hidden'} marginTop={'5px'}>
        <Image
          src={review.reviewer?.profilePath || '/images/avatar.png'}
          objectFit={'cover'}
          width={'100%'}
          height={'100%'}
        />
      </HorizontalView>
      {!isEdit && (
        <VerticalView alignContent={'centerLeft'} width={'calc(100% - 70px)'} paddingLeft={'20px'}>
          <HorizontalView>
            <TextDisplay size={appSize.h4} color={AppColors.BLACK} fontWeight={500}>
              {review.reviewer?.name && review.reviewer?.name.length > 0
                ? review.reviewer?.name
                : translation('reviewer')}
            </TextDisplay>
            {props.auth?.id === review.userId && (
              <TextDisplay size={appSize.h4} color={AppColors.BLACK} fontWeight={500}>
                ({translation('you')})
              </TextDisplay>
            )}
            {props.review.isVerifiedPurchase && (
              <HorizontalView paddingLeft={'10px'}>
                <SVGIcon name={'check-circle'} color={'green'} size={'15px'} />
              </HorizontalView>
            )}
          </HorizontalView>
          <HorizontalView>
            <RateView star={review.rate || 0} starSize={'15px'} fontSize={'11px'} />
            <TextDisplay size={appSize.h5} color={AppColors.DARK} marginLeft={'10px'}>
              {review.createdTime !== review.updatedTime
                ? `${translation('updatedTime')} ${dateUtil.formatTimeAgo(review.updatedTime)}`
                : dateUtil.formatTimeAgo(review.createdTime)}
            </TextDisplay>
          </HorizontalView>

          <TextDisplay size={appSize.h4} color={AppColors.DARK}>
            {review.content}
          </TextDisplay>
          {props.auth?.id === review.userId && (
            <HorizontalView fullWidth alignContent={'centerRight'} marginTop={'10px'}>
              <Button
                fontSize={'15px'}
                width={'auto'}
                text={translation('editReview')}
                fontWeight={700}
                color={AppColors.PRIMARY}
                onClick={() => setIsEdit(true)}
              />
            </HorizontalView>
          )}
        </VerticalView>
      )}
      {isEdit && review.courseId && (
        <VerticalView alignContent={'centerLeft'} width={'calc(100% - 70px)'} paddingLeft={'20px'}>
          <AnimationView width={'100%'}>
            <WriteReviewBar
              isEdit
              auth={props.auth}
              rate={review.rate}
              content={review.content}
              onEditReview={(rate, content) => {
                props.onEditReview(review.id, rate, content);
                setIsEdit(false);
              }}
            />
          </AnimationView>
        </VerticalView>
      )}
    </HorizontalView>
  );
};

export const ReviewList = (props: ReviewListProps) => {
  const { reviews, loading, totalPages, page, onChangePage } = useGetReviewList(props.courseId, 20);
  const { translation } = useTranslationText();
  const [isShowReview, setShowReview] = React.useState(false);

  const isReview = Boolean(reviews.find((review) => review.userId === props.auth?.id));

  return (
    <VerticalView
      fullWidth
      alignContent={'centerLeft'}
      padding={'15px'}
      border={`1px solid ${AppColors.BORDER}`}
      borderRadius={'4px'}
      background={AppColors.BACKGROUND_REVIEW}
    >
      <Div fullWidth marginBottom={'15px'}>
        <HorizontalView fullWidth alignContent={'centerBetween'} paddingLeft={'15px'} paddingRight={'15px'}>
          <TextDisplay size={'20px'} color={AppColors.BLACK} fontWeight={'bold'} marginRight={'20px'}>
            {translation('studentReview')}
          </TextDisplay>

          {!isReview && props.isValidReview && props.auth?.id && props.auth?.id !== props.createdBy && (
            <Button
              fontSize={'15px'}
              text={translation('writeReview')}
              fontWeight={700}
              color={'#1990FF'}
              onClick={() => setShowReview(!isShowReview)}
            />
          )}
        </HorizontalView>
      </Div>
      <Hr />
      {!isReview && isShowReview && props.auth && (
        <Div fullWidth alignContent={'centerLeft'} marginTop={'15px'}>
          {/* ReviewBar Author */}
          <WriteReviewBar
            auth={props.auth}
            onCreateReview={(rate, content) => {
              setShowReview(false);
              props.onCreateReview(rate, content);
            }}
          />
        </Div>
      )}
      <VerticalView fullWidth alignContent={'centerLeft'} marginTop={'15px'}>
        {reviews.map((review, i) => {
          return (
            <VerticalView fullWidth alignContent={'centerLeft'} key={i} paddingBottom={'20px'}>
              <ReviewCard auth={props.auth} review={review} onEditReview={props.onEditReview} />
              {i !== reviews.length - 1 && <Hr height={'1px'} />}
            </VerticalView>
          );
        })}
        {reviews.length === 0 && !loading && <>{translation('noReviewData')}</>}
        {totalPages > 1 && (
          <VerticalView fullWidth alignContent={'centerRight'}>
            <AnimationView animation={'fadeIn'}>
              <PaginationBar totalPages={totalPages} currentPage={page} onChangePage={(index) => onChangePage(index)} />
            </AnimationView>
          </VerticalView>
        )}
      </VerticalView>
    </VerticalView>
  );
};

type ReviewListOfAuthorProps = {
  auth?: IUser;
  isValidReview: boolean;
  createdBy?: string;
  authorId: string;
  onEditReview: (id: string, rate: number, content: string) => void;
  onCreateReview: (rate: number, content: string) => void;
};

export const ReviewListOfAuthor = (props: ReviewListOfAuthorProps) => {
  const { reviews, loading, page, totalPages, onChangePage, onSearchReviews } = useSearchReviews();
  const { translation } = useTranslationText();
  const [isShowReview, setShowReview] = React.useState(false);

  const isReview = Boolean(reviews.find((review) => review.userId === props.auth?.id));

  React.useEffect(() => {
    if (!props.authorId) {
      return;
    }
    onSearchReviews({
      limit: 10,
      page: 1,
      authorId: props.authorId,
    } as ISearchReviewsInput);
  }, [props.authorId]);

  return (
    <VerticalView
      fullWidth
      alignContent={'centerLeft'}
      padding={'15px'}
      border={`1px solid ${AppColors.BORDER}`}
      borderRadius={'4px'}
      background={AppColors.BACKGROUND_REVIEW}
    >
      <Div fullWidth marginBottom={'15px'}>
        <HorizontalView fullWidth alignContent={'centerBetween'} paddingLeft={'15px'} paddingRight={'15px'}>
          <TextDisplay size={'20px'} color={AppColors.BLACK} fontWeight={'bold'} marginRight={'20px'}>
            {translation('studentReview')}
          </TextDisplay>

          {!isReview && props.isValidReview && props.auth?.id && props.auth?.id !== props.createdBy && (
            <Button
              fontSize={'15px'}
              text={translation('writeReview')}
              fontWeight={700}
              color={'#1990FF'}
              onClick={() => setShowReview(!isShowReview)}
            />
          )}
        </HorizontalView>
      </Div>
      <Hr />
      {!isReview && isShowReview && props.auth && (
        <Div fullWidth alignContent={'centerLeft'} marginTop={'15px'}>
          {/* ReviewBar Author */}
          <WriteReviewBar
            auth={props.auth}
            onCreateReview={(rate, content) => {
              setShowReview(false);
              props.onCreateReview(rate, content);
            }}
          />
        </Div>
      )}
      <VerticalView fullWidth alignContent={'centerLeft'} marginTop={'15px'}>
        {reviews.map((review, i) => {
          return (
            <VerticalView fullWidth alignContent={'centerLeft'} key={i} paddingBottom={'20px'}>
              <ReviewCard auth={props.auth} review={review} onEditReview={props.onEditReview} />
              {i !== reviews.length - 1 && <Hr height={'1px'} />}
            </VerticalView>
          );
        })}
        {reviews.length === 0 && !loading && <>{translation('noReviewData')}</>}
        {totalPages > 1 && (
          <VerticalView fullWidth alignContent={'centerRight'}>
            <AnimationView animation={'fadeIn'}>
              <PaginationBar totalPages={totalPages} currentPage={page} onChangePage={(index) => onChangePage(index)} />
            </AnimationView>
          </VerticalView>
        )}
      </VerticalView>
    </VerticalView>
  );
};
